export default __webpack_public_path__ + "static/media/hosting4.be21c7ef.png";